import React from "react";
import { TimeOffManagementRoutes } from "./TimeOffManagementRoutes";

export const TimeOffManagement = () => {
  return (
    <div>
      <TimeOffManagementRoutes></TimeOffManagementRoutes>
    </div>
  );
}